<template>
  <div class="ranking-print-winners">
    <small>
    <table>
      <thead>
        <th style="max-width: 35px;">Posi.</th>
        <th>Nome</th>
        <!-- <th style="width: 95px;">Cpf</th> -->
        <th>UC</th>
        <!-- <th style="max-width: 100px;">Telefone</th> -->
        <th style="max-width: 40px;">Nota</th>
        <!-- <th style="width: 40px;">Aprov.</th> -->
      </thead>
      <tbody>
        <tr v-for="(ticket, index) in tickets" :key="index" >
          <td> {{ ticket.rankingNow }} </td>
          <td> {{ ticket.customer.holder }} </td>
          <!-- <td> {{ ticket.customer.cpf }} </td> -->
          <td> {{ ticket.customer.uc }} </td>
          <!-- <td> {{ ticket.customer.phones[1] !== "" ? ticket.customer.phones.join(' | ') : ticket.customer.phones[0] }} </td> -->
          <td> {{ ticket.survey.data.refrigerator.score }} </td>
          <!-- <td></td> -->
        </tr>
      </tbody>
    </table>
    </small>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'ranking-print-winners',

  computed: {
    eventId () {
      return this.$route.params.id
    },

    tickets: {
      get () {
        return this.$store.state.tickets.all.filter(ticket => {
          return this.surveys.find(survey => {
            return survey.ticketId === ticket._id
          }) && ticket.eligible && ticket.winner
        }).sort((a, b) => {
          return a.rankingNow - b.rankingNow
        }).map(ticket => {
          ticket.survey = this.surveys.find(survey => {
            return survey.ticketId === ticket._id
          })
          return ticket
        })
      }
    },

    surveys: {
      get () {
        return this.$store.state.surveys.all.filter(survey => {
          return survey.status === 'FINISHED' && (!survey.alert || survey.alert === 'false') && survey.hasOwnProperty('data') && (!survey.data.absent || survey.data.absent === 'false') && (survey.data.accepted && survey.data.accepted !== 'false')
        })
      }
    }
  },

  methods: {
    ...mapActions('tickets', ['fetchTicketsWithCustomersByEvent']),

    ...mapActions('surveys', {
      fetchSurveys: 'fetchAll'
    }),

    getPhones (customer) {
      return customer.phones.join(' / ')
    }
  },

  mounted () {
    this.fetchTicketsWithCustomersByEvent({
      where: {
        eligible: true,
        surveyAssociated: true
      },
      eventId: this.eventId
    })

    this.fetchSurveys({
      where: [ { 'event._id': this.eventId } ]
    })
  }
}
</script>

<style scoped>
@page {
  margin: 0.3cm;
}
table {
  width: 100%
}
td, th {
  padding: 0px 1px 1px 1px;
  border: 1px solid;
}
</style>




// WEBPACK FOOTER //
// src/pages/Ranking/RankingPrintWinners.vue